import angular from 'angular';
import uiRouter from 'angular-ui-router';
import privacyDeclarationComponent from './privacyDeclaration.component';

let privacyDeclarationModule = angular.module('privacyDeclaration', [
  uiRouter
])

.component('privacyDeclaration', privacyDeclarationComponent)

.name;

export default privacyDeclarationModule;



// WEBPACK FOOTER //
// ./client/app/common/privacyDeclaration/privacyDeclaration.js